import Vue from 'vue'
import Vuex from 'vuex'
import { login as loginApi } from '@/api/auth'
import { setToken, removeToken, setAdminInfo, getAdminInfo, getToken } from '@/utils/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: getToken() || '',
    adminInfo: getAdminInfo() || {}
  },
  getters: {
    token: state => state.token,
    adminInfo: state => state.adminInfo,
    isLoggedIn: state => !!state.token,
    isSuperAdmin: state => state.adminInfo && state.adminInfo.roleId === 1,
    isServiceAdmin: state => state.adminInfo && state.adminInfo.roleId === 3,
    permissions: state => {
      if (!state.adminInfo || !state.adminInfo.roleId) return []
      // roleId 1=超级管理员, 2=普通管理员, 3=客服管理员
      return state.adminInfo.roleId === 1 ? ['all'] : []
    }
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      setToken(token)
    },
    SET_ADMIN_INFO(state, info) {
      state.adminInfo = info
      setAdminInfo(info)
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.adminInfo = {}
      removeToken()
    }
  },
  actions: {
    async login({ commit }, credentials) {
      const data = await loginApi(credentials)
      commit('SET_TOKEN', data.token)
      commit('SET_ADMIN_INFO', {
        id: data.adminId,
        username: data.username,
        nickname: data.nickname,
        roleId: data.roleId
      })
      return data
    },
    logout({ commit }) {
      commit('CLEAR_AUTH')
    }
  }
})
